export default __webpack_public_path__ + "static/media/thum8.2c8b9ebd.jpg";